import styles from './Cashflow.module.scss'
import {
  CashflowForecast,
  CashflowMainStat,
  CashflowMiniStat,
  ForecastPerformance,
} from '.'

export default function Cashflow() {
  return (
    <div className={styles.root}>
      <CashflowForecast />
      <CashflowMainStat />
      <div className={styles.grid}>
        <CashflowMiniStat name="transactions" />
        <CashflowMiniStat name="forecast" />
      </div>
      <ForecastPerformance />
    </div>
  )
}
